import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {PhotoDownloadService} from '../photo-download.service';
import {PhotoDownload} from '../../models/photo-download';

@Injectable({
    providedIn: 'root'
})
export class PhotoDownloadServiceMock implements PhotoDownloadService {
    detail(fileName: string): Observable<PhotoDownload> {
        return of({
            fileName,
            blobUrl: 'https://prs.nl/afbeelding.jpg',
        })
    }

    enqueue(projectReferenceId: number): Observable<PhotoDownload> {
        return of({
            fileName: 'afbeelding.jpg',
            blobUrl: null,
        })
    }
}
